<template>
  <div class="loading-page">
    <div class="spinner-box-container">
      <div class="spinner-box">
        <div
          data-v-3411a4c5=""
          class="hollow-dots-spinner"
          size="80"
          style="height: 15px; width: 90px"
        >
          <div
            data-v-3411a4c5=""
            class="dot"
            style="
              animation-delay: 300ms;
              animation-duration: 1500ms;
              width: 15px;
              height: 15px;
              margin: 0px 7.5px;
              border-width: 3px;
              border-color: rgb(74, 227, 135);
            "
          ></div>
          <div
            data-v-3411a4c5=""
            class="dot"
            style="
              animation-delay: 600ms;
              animation-duration: 1500ms;
              width: 15px;
              height: 15px;
              margin: 0px 7.5px;
              border-width: 3px;
              border-color: rgb(74, 227, 135);
            "
          ></div>
          <div
            data-v-3411a4c5=""
            class="dot"
            style="
              animation-delay: 900ms;
              animation-duration: 1500ms;
              width: 15px;
              height: 15px;
              margin: 0px 7.5px;
              border-width: 3px;
              border-color: rgb(74, 227, 135);
            "
          ></div>
        </div>
      </div>
      <span>{{ $t("loading") }}</span>
    </div>
  </div>
</template>

<script>
import { request, getQueryString } from "@/utils/utils.js";
import { mapMutations } from "vuex";
import pageName from "../../NewUser/pageNames";

export default {
  name: "redirect-page",
  data() {
    return {
      refreshToken: "",
      accessToken: "",
      callBackNO: 0,
      permissions: {
        // [pageName.transactions]: false,
        [pageName.report]: false,
        [pageName.appManagement]: false,
        [pageName.finance]: false,
        [pageName.merchantKyc]: false,
        [pageName.userManagement]: false,
        [pageName.wayBill]: false,
      },
    };
  },
  created() {
    // 获取刷新token 跳转登录

    this.setRefreshToken();
  },
  mounted() {
    this.getAccessToken();

  },
  methods: {
    ...mapMutations(["setUser"]),
    getUserData() {
      request({
        method: "post",
        url: "api/dashboard/app/user/query?access_token=" + this.accessToken,
      })
        .then((response) => {
          if (response.data.code == "10000") {
            let isAdmin =
              response.data.data.role === "MERCHANT_ADMIN" ? true : false;
            if (isAdmin) {
              for (let i in this.permissions) {
                this.permissions[i] = true;
              }
              this.permissions[pageName.finance] = response.data.data
                .show_finance
                ? true
                : false;
              this.permissions[pageName.virtualAccount] = response.data.data
                .show_virtual_account
                ? true
                : false;
            } else {
              response.data.data.permission.forEach((item) => {
                if (this.permissions[item.name] !== undefined) {
                  this.permissions[item.name] =
                    item.privileges[0] === "View" ? true : false;
                }
              });
              if (!response.data.data.show_finance) {
                this.permissions[pageName.finance] = false;
              }
              if (!response.data.data.show_virtual_account) {
                this.permissions[pageName.virtualAccount] = false;
              }
            }

            this.setUser({
              info: response.data,
              permissions: this.permissions,
            });
            localStorage.setItem("userInfo", JSON.stringify({
              info: response.data,
              permissions: this.permissions,
            }));
            this.goHome();
          } else {
            this.$router.replace({
              name: "systemError",
            });
          }
        })
        .catch((err) => {
          localStorage.clear();
          this.$router.replace({
            name: "redirectPage",
          });
        });
    },
    setRefreshToken() {
      if (location.pathname === "/forward") {
        this.refreshToken = getQueryString("rc");
        localStorage.setItem("refresh_token", this.refreshToken);
      } else {
        return;
      }
    },
    getAccessToken() {
      if (this.refreshToken) {
        request({
          method: "post",
          url: `api/dashboard/refresh?refresh_token=${this.refreshToken}`,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then((res) => {
            window.isRefreshing = false;
            var respData = res.data;
            if (respData.code === "10000") {
              var tokenVo = {
                Authorization: respData.data.access_token,
                refreshToken: respData.data.refresh_token,
              };
              var newToken = tokenVo.Authorization;
              this.accessToken = newToken;
              localStorage.setItem("Authorization", newToken);
              localStorage.setItem("sessionTime", respData.data.expires_in);
              localStorage.setItem("startTime", new Date().getTime());
              localStorage.setItem("refresh_token", tokenVo.refreshToken);
              this.getUserData();
            } else {
              if (respData.code === "20002") {
                ++this.callBackNO;
                if (this.callBackNO <= 3) {
                  this.getAccessToken();
                } else {
                  this.$router.replace({
                    name: "systemError",
                  });
                }
              } else {
                this.$router.replace({
                  name: "systemError",
                });
              }
            }
          })
          .catch((err) => {
            console.log(err);
            localStorage.clear();
            this.$router.replace({
              name: "redirectPage",
            });
          });
      } else {
        return;
      }
    },
    goHome() {
      // 跳转Dashboard 首页，首页的路径是 /Dashboard
      this.$router.replace({
        name: "PaymentOrder",
      });
    },
  },
};
</script>

<style lang="scss">
.loading-page {
  width: 100vw;
  height: 100vh;
  background-color: #808080;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.spinner-box-container {
  width: 240px;
  height: 150px;
  text-align: center;
  padding-bottom: 40px;
}
.spinner-box {
  height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.hollow-dots-spinner {
  box-sizing: border-box;
}
.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid #ff1d5e;
  border-radius: 50%;
  float: left;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-animation: hollow-dots-spinner-animation-data-v-3411a4c5 1000ms ease
    infinite 0ms;
  animation: hollow-dots-spinner-animation-data-v-3411a4c5 1000ms ease infinite
    0ms;
}

.hollow-dots-spinner,
.hollow-dots-spinner * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hollow-dots-spinner {
  height: 15px;
  width: calc(30px * 3);
}
.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid #ff1d5e;
  border-radius: 50%;
  float: left;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-animation: hollow-dots-spinner-animation-data-v-3411a4c5 1000ms ease
    infinite 0ms;
  animation: hollow-dots-spinner-animation-data-v-3411a4c5 1000ms ease infinite
    0ms;
}
.hollow-dots-spinner .dot:nth-child(1) {
  -webkit-animation-delay: calc(300ms * 1);
  animation-delay: calc(300ms * 1);
}
.hollow-dots-spinner .dot:nth-child(2) {
  -webkit-animation-delay: calc(300ms * 2);
  animation-delay: calc(300ms * 2);
}
.hollow-dots-spinner .dot:nth-child(3) {
  -webkit-animation-delay: calc(300ms * 3);
  animation-delay: calc(300ms * 3);
}
@-webkit-keyframes hollow-dots-spinner-animation-data-v-3411a4c5 {
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes hollow-dots-spinner-animation-data-v-3411a4c5 {
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.spinner-box-container span {
  font-size: 1rem;
  color: white;
}
</style>
